import { css } from '@/styled-system/css';
import { styled } from '@/styled-system/jsx';
import ImageLoader from '../photo-gallery/ImageLoader';
import LazyLoader from 'app/shared/modules/LazyLoader';
import Text from 'app/shared/core/Text';

export const ComparisonTableWrapper = styled('table', {
  base: {
    fontSize: 'sm',
    lineHeight: 'tiny',
  },
});

export const ColgroupCategory = styled('col', {
  base: {
    width: '90px',
  },
});

export const ColgroupFirstCol = styled('col', {
  base: {
    width: '124px',
  },
});

export const ColgroupStandardCol = styled('col', {
  base: {
    width: '116px',
  },
});

export const TableHeader = styled('thead', {
  base: {
    verticalAlign: 'top',
  },
});

export const TableHeaderFirstItem = styled('th', {
  base: {
    paddingTop: '0',
    paddingRight: '8px',
    paddingBottom: '0',
    paddingLeft: '16px',
  },
});

export const TableHeaderStandardItem = css({
  paddingTop: '0',
  paddingRight: '8px',
  paddingBottom: '0',
  paddingLeft: '8px',
});

export const TableHeaderPhotoContainer = styled('div', {
  base: {
    width: '100px',
    height: '100px',
    position: 'relative',
  },
});

export const TableHeaderPhoto = styled(ImageLoader, {
  base: {
    objectFit: 'cover',
    height: '100%',
    width: '100%',
    borderRadius: '4px',
  },
});

export const TableHeaderPhotoPlaceholder = styled(LazyLoader, {
  base: {
    borderTopLeftRadius: '3px',
    borderTopRightRadius: '0',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '3px',
    backgroundColor: 'hpxGrey100',
  },
});

// Title-related styles
export const HeaderTitleContainer = styled('div', {
  base: {
    paddingTop: '8px',
  },
});

export const HeaderTitle = styled(Text, {
  base: {
    fontWeight: 'bold',
    fontSize: '14px',
    lineHeight: '16px',
    _hover: {
      textDecoration: 'underline',
    },
  },
});

export const HeaderTitleNonLinked = styled(Text, {
  base: {
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '16px',
  },
});

export const HeaderTitleSecondary = styled(Text, {
  base: {
    fontWeight: 'bold',
  },
});

// Table Body styles
export const TableBody = styled('tbody', {
  base: {
    color: '#212a3b', // hpx-blue-600
  },
  variants: {
    striped: {
      true: {
        '& tr:nth-child(even)': {
          backgroundColor: '#f2f2f2', // hpx-grey-100
        },
      },
    },
  },
});

// Category cell styles
export const CategoryCell = styled('td', {
  base: {
    color: '#6e6e6e', // hpx-grey-600
    textAlign: 'right',
    paddingTop: '8px',
    paddingRight: '4px',
    paddingBottom: '8px',
    paddingLeft: '0',
    borderRightWidth: '1px',
    borderRightStyle: 'solid',
    borderRightColor: '#f2f2f2', // hpx-grey-100
  },
  variants: {
    firstRow: {
      true: {
        paddingTop: '16px',
        paddingRight: '0',
        paddingBottom: '16px',
        paddingLeft: '0',
      },
    },
  },
});

export const CategorySubcatCell = styled('div', {
  base: {
    paddingTop: '4px',
    paddingRight: '0',
    paddingBottom: '4px',
    paddingLeft: '0',
  },
  variants: {
    position: {
      first: {
        paddingBottom: '4px',
      },
      last: {
        paddingTop: '4px',
      },
    },
  },
});

// Data cell styles
export const DataCell = styled('td', {
  base: {
    paddingTop: '8px',
    paddingRight: '8px',
    paddingBottom: '8px',
    paddingLeft: '8px',
  },
  variants: {
    firstRow: {
      true: {
        fontWeight: 'bold',
      },
    },
    firstCol: {
      true: {
        paddingTop: '0',
        paddingRight: '8px',
        paddingBottom: '0',
        paddingLeft: '16px',
      },
    },
  },
});

export const PlaceholderCell = styled('div', {
  base: {
    color: '#949494', // hpx-grey-500
    fontWeight: 'normal',
  },
});

// Tableless header
export const TablelessHeader = styled('div', {
  base: {
    display: 'flex',
  },
});

// Misc styles
export const CheckmarkImage = styled('img', {
  base: {
    height: '16px',
    width: '16px',
  },
});
